module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.0ac6925a.webp";